import { Modal } from 'cpool-components/general/Modal';
import { useTranslation } from 'react-i18next';

import { DuplicatesTable } from '~/components/DuplicateModal/DuplicatesTable';

type DialogBoxProps = {
    open: boolean;
    onClose: () => void;
    dataTestId?: string;
    loanRequestId: string;
};

export const DuplicateModal: React.FC<DialogBoxProps> = ({ dataTestId, loanRequestId, onClose, open }) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={t('DUPLICATE_LIST.TITLE')}
            panelClassName="w-[82%] min-w-[560px] max-w-none"
        >
            <div data-testid={dataTestId} className="h-full overflow-auto">
                <DuplicatesTable loanRequestId={loanRequestId} />
            </div>
        </Modal>
    );
};
